import { User } from "../@core/data/users";

export class Receipt {
  id?: string;

  //receipt
  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  code?: string;
  warehouseId?: string;
  warehouseName?: string;
  userId?: string;
  note?: string;
  tags?: string[];

  totalDiscountAmount?: number;
  detailDiscountAmount?: number;
  discountAmount?: number;
  discountPercent?: number;
  detailAmount?: number;
  detailNetAmount?: number;
  totalQuantity?: number;
  totalAmount?: number;
  vatPercent?: number;
  vatAmount?: number;
  points?: number;
  ratePoints?: number;
  isCancel?: boolean;
  isClosed?: boolean;
  isPrint?: boolean;
  status?: string;
  noPrint?: number;
  isTrade?: boolean;
  totalCostAmount?: number;
  totalProfit?: number;

  //customer - membership
  membershipCardId?: string;
  membershipTypeName?: string;
  customerId?: string;
  // customer?: Customer;
  customerName?: string;
  customerMobile?: string;
  customerAddress?: string;
  customerTaxCode?: string;
  lastDebitAmount?: number;

  //Sale-Delivery
  employeeCounSellorId?: string;
  employeeCounSellorName?: string;
  employeeSaleId?: string;
  employeeSaleName?: string;
  employeeDeliveryId?: string;
  employeeDeliveryName?: string;

  isDelivery?: boolean;
  deliveryDate?: Date;
  deliveryNote?: string;
  isDelivered?: boolean;
  deliveredDate?: Date;
  deliveredNote?: string;
  deliveredAmount?: number;

  //Cashier
  cashierName?: string;

  //payment
  isCash?: boolean;
  paymentAmount?: number;
  paymentRefund?: number;
  //payment detail
  paymentDate?: Date;
  isDebit?: boolean;
  paymentDebit?: number;
  paymentPaidType?: string; //Cash/Visa/Point/Voucher
  paymentPaidPoint?: number;
  paymentPaidVisa?: number;
  paymentPaidCash?: number;
  paymentPaidVoucher?: number;
  paymentId?: string;

  //detail
  receiptDetails?: ReceiptDetail[];
  isDetailChanged?: boolean;
  //inventory
  isInventory?: boolean;
  IssueDateInventory?: Date;

  //render
  isMore?: boolean;
  isFinished?: boolean;

  //info receipt view for report product
  receipts?: Receipt[];

  sharedLinkId?: string;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class ReceiptDetail {
  id?: string;
  issueDate?: Date;
  receiptId?: string;
  productInventoryId?: string;

  productId?: string;
  productCode: string;
  productName: string;
  productDescription: string;
  productUnitName: string;
  productCostPrice: number;
  //Advance
  productUnitId?: string;
  productGroupId?: string;
  productGroupName?: string;
  productCategoryId?: string;
  productCategoryName?: string;
  productSupplierId?: string;
  productSupplierName?: string;
  productProducerId?: string;
  productProducerName?: string;
  productOriginId?: string;
  productOriginName?: string;
  productSizeId?: string;
  productSizeName?: string;
  productColorId?: string;
  productColorName?: string;

  discountPercent: number;
  discountAmount: number;
  quantity: number;
  price: number;
  amount: number;
  netAmount: number;
  comment: string;

  //trade
  supplierId?: string;
  supplierName?: string;
  costQuantity: number;
  costPrice: number;
  costAmount: number;
  customerId?: string;
  customerName?: string;
  customerMobile?: string;
  customerAddress?: string;
  customerTaxCode?: string;

  profit?: number;

  //info receipt view for report product
  receipts?: Receipt[];
  receipt?: Receipt;
  receiptTotalAmount?: number;
  timestamp?: number;
  isDeleted?: boolean;
  isActive?: boolean;
}

//Order
export class ReceiptOrder {
  id?: string;

  //receipt
  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  code?: string;
  warehouseId?: string;
  warehouseName?: string;
  userId?: string;
  note?: string;
  tags?: string[];

  totalDiscountAmount?: number;
  detailDiscountAmount?: number;
  discountAmount?: number;
  discountPercent?: number;
  detailAmount?: number;
  detailNetAmount?: number;
  totalQuantity?: number;
  totalAmount?: number;
  vatPercent?: number;
  vatAmount?: number;
  points?: number;
  ratePoints?: number;
  isCancel?: boolean;
  isClosed?: boolean;
  isPrint?: boolean;
  status?: string;
  noPrint?: number;
  isTrade?: boolean;
  totalCostAmount?: number;
  totalProfit?: number;

  //customer - membership
  membershipCardId?: string;
  membershipTypeName?: string;
  customerId?: string;
  // customer?: Customer;
  customerName?: string;
  customerMobile?: string;
  customerAddress?: string;
  lastDebitAmount?: number;

  //Sale-Delivery
  employeeCounSellorId?: string;
  employeeCounSellorName?: string;
  employeeSaleId?: string;
  employeeSaleName?: string;
  employeeDeliveryId?: string;
  employeeDeliveryName?: string;

  isDelivery?: boolean;
  deliveryDate?: Date;
  deliveryNote?: string;
  isDelivered?: boolean;
  deliveredDate?: Date;
  deliveredNote?: string;
  deliveredAmount?: number;

  //Cashier
  cashierName?: string;

  //payment
  isCash?: boolean;
  paymentAmount?: number;
  paymentRefund?: number;
  //payment detail
  paymentDate?: Date;
  isDebit?: boolean;
  paymentDebit?: number;
  paymentPaidType?: string; //Cash/Visa/Point/Voucher
  paymentPaidPoint?: number;
  paymentPaidVisa?: number;
  paymentPaidCash?: number;
  paymentPaidVoucher?: number;
  paymentId?: string;

  //detail
  receiptOrderDetails?: ReceiptOrderDetail[];
  isDetailChanged?: boolean;
  //inventory
  isInventory?: boolean;
  IssueDateInventory?: Date;

  //render
  isMore?: boolean;

  //info receipt view for report product
  receiptOrders?: ReceiptOrder[];

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class ReceiptOrderDetail {
  id?: string;
  issueDate?: Date;
  receiptId?: string;
  productInventoryId?: string;

  productId?: string;
  productCode: string;
  productName: string;
  productDescription: string;
  productUnitName: string;
  productCostPrice: number;
  //Advance
  productUnitId?: string;
  productGroupId?: string;
  productGroupName?: string;
  productCategoryId?: string;
  productCategoryName?: string;
  productSupplierId?: string;
  productSupplierName?: string;
  productProducerId?: string;
  productProducerName?: string;
  productOriginId?: string;
  productOriginName?: string;
  productSizeId?: string;
  productSizeName?: string;
  productColorId?: string;
  productColorName?: string;

  discountPercent: number;
  discountAmount: number;
  quantity: number;
  price: number;
  amount: number;
  netAmount: number;
  comment: string;

  //trade
  supplierId?: string;
  supplierName?: string;
  costQuantity: number;
  costPrice: number;
  costAmount: number;
  customerId?: string;
  customerName?: string;
  profit?: number;

  //info receipt view for report product
  receiptOrders?: ReceiptOrder[];
  receiptOrder?: ReceiptOrder;

  timestamp?: number;
}

//Inventory
export class ReceiptInventory {
  id?: string;

  //receipt
  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  code?: string;
  warehouseId?: string;
  warehouseName?: string;
  userId?: string;
  note?: string;
  tags?: string[];

  detailAmount?: number;
  detailNetAmount?: number;
  totalQuantity?: number;
  totalAmount?: number;

  isCancel?: boolean;
  isClosed?: boolean;
  isPrint?: boolean;
  status?: string;
  noPrint?: number;
  isTrade?: boolean;
  totalCostAmount?: number;
  totalProfit?: number;

  //Sale-Delivery
  employeeCounSellorId?: string;
  employeeCounSellorName?: string;
  employeeSaleId?: string;
  employeeSaleName?: string;
  employeeDeliveryId?: string;
  employeeDeliveryName?: string;

  isDelivery?: boolean;
  deliveryDate?: Date;
  deliveryNote?: string;
  isDelivered?: boolean;
  deliveredDate?: Date;
  deliveredNote?: string;
  deliveredAmount?: number;

  //Cashier
  cashierName?: string;

  //detail
  receiptInventoryDetails?: ReceiptInventoryDetail[];
  isDetailChanged?: boolean;

  //render
  isMore?: boolean;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class ReceiptInventoryDetail {
  id?: string;
  issueDate?: Date;
  receiptId?: string;
  productInventoryId?: string;

  productId?: string;
  productCode: string;
  productName: string;
  productDescription: string;
  productUnitName: string;
  productCostPrice: number;
  //Advance
  productUnitId?: string;
  productGroupId?: string;
  productGroupName?: string;
  productCategoryId?: string;
  productCategoryName?: string;
  productSupplierId?: string;
  productSupplierName?: string;
  productProducerId?: string;
  productProducerName?: string;
  productOriginId?: string;
  productOriginName?: string;
  productSizeId?: string;
  productSizeName?: string;
  productColorId?: string;
  productColorName?: string;

  quantity: number;
  price: number;
  amount: number;
  netAmount: number;
  comment: string;

  timestamp?: number;
}
